import TrialEmailConfirmation from './TrialEmailConfirmation'

export default TrialEmailConfirmation
